import { Box, Button } from "@material-ui/core";
import React, { ReactNode } from "react";

export type TableSwitcherOption<T> = Readonly<{
  value: T;
  label: ReactNode;
  hide?: boolean;
}>;

export type TableSwitcherProps<T> = Readonly<{
  selected: T;
  onTabSelected: (tabOption: T) => void;
  options: TableSwitcherOption<T>[];
}>;

function TableSwitcher<T>(props: TableSwitcherProps<T>) {
  const optionsJsx = props.options
    .filter((o) => !o.hide)
    .map((option, idx) => (
      <Button
        key={idx}
        style={{
          backgroundColor: props.selected === option.value ? "#fff" : undefined,
          borderRadius: "12px",
          flexGrow: 1,
        }}
        onClick={() => props.onTabSelected(option.value)}
      >
        {option.label}
      </Button>
    ));


  if (optionsJsx.length < 2) {
    return <></>;
  }

  return (
    <Box
      sx={{
        p: 0.5,
        borderRadius: "16px",
        width: "100%",
        display: "flex",
        bgcolor: "#efefef",
        gridGap: "0.5rem",
      }}
    >
      {optionsJsx}
    </Box>
  );
}

export default TableSwitcher;
